import { render, staticRenderFns } from "./LocationSection.vue?vue&type=template&id=8ed521ce"
import script from "./LocationSection.vue?vue&type=script&lang=js"
export * from "./LocationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports